module.exports = __webpack_public_path__ + "static/img/1.2688a2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/1.png
// module id = e1YU
// module chunks = 0